export default {
  headers: [
    ['fleet/vehicle.registration', 'registration'],
    ['satellite-tracking/report.vehicle_make_model', 'vehicleLabel'],
    ['satellite-tracking/report.drivers', 'drivers'],
    ['satellite-tracking/report.start_time', 'startTime'],
    ['satellite-tracking/report.start_address', 'startAddress'],
    ['satellite-tracking/report.end_time', 'endTime'],
    ['satellite-tracking/report.end_address', 'endAddress'],
    ['satellite-tracking/report.total_working_time', 'duration'],
    ['satellite-tracking/report.idle_vehicle_operation', 'idleTime'],
    ['satellite-tracking/report.effective_working_hours', 'effectiveWorkingHours']
  ]
}
